import { render, staticRenderFns } from "./ReportBoard.vue?vue&type=template&id=72a353b2&scoped=true&"
import script from "./ReportBoard.vue?vue&type=script&lang=js&"
export * from "./ReportBoard.vue?vue&type=script&lang=js&"
import style0 from "./ReportBoard.vue?vue&type=style&index=0&id=72a353b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a353b2",
  null
  
)

export default component.exports